/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new task template
 * @export
 * @interface CreateTaskTemplateRequest
 */
export interface CreateTaskTemplateRequest {
    /**
     * Title of the task
     * @type {string}
     * @memberof CreateTaskTemplateRequest
     */
    title: string;
    /**
     * Optional description of the task
     * @type {string}
     * @memberof CreateTaskTemplateRequest
     */
    description?: string | null;
    /**
     * Task priority level
     * @type {string}
     * @memberof CreateTaskTemplateRequest
     */
    priority?: CreateTaskTemplateRequestPriorityEnum;
    /**
     * Number of days after status change when task is due
     * @type {number}
     * @memberof CreateTaskTemplateRequest
     */
    dueDaysOffset?: number | null;
    /**
     * Role that should be assigned this task
     * @type {string}
     * @memberof CreateTaskTemplateRequest
     */
    assigneeRole?: string | null;
    /**
     * Order in which tasks should be displayed
     * @type {number}
     * @memberof CreateTaskTemplateRequest
     */
    displayOrder?: number;
    /**
     * Whether this task is required to complete the status
     * @type {boolean}
     * @memberof CreateTaskTemplateRequest
     */
    isRequired?: boolean;
}


/**
 * @export
 */
export const CreateTaskTemplateRequestPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Urgent: 'urgent'
} as const;
export type CreateTaskTemplateRequestPriorityEnum = typeof CreateTaskTemplateRequestPriorityEnum[keyof typeof CreateTaskTemplateRequestPriorityEnum];


/**
 * Check if a given object implements the CreateTaskTemplateRequest interface.
 */
export function instanceOfCreateTaskTemplateRequest(value: object): value is CreateTaskTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CreateTaskTemplateRequestFromJSON(json: any): CreateTaskTemplateRequest {
    return CreateTaskTemplateRequestFromJSONTyped(json, false);
}

export function CreateTaskTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dueDaysOffset': json['dueDaysOffset'] == null ? undefined : json['dueDaysOffset'],
        'assigneeRole': json['assigneeRole'] == null ? undefined : json['assigneeRole'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
    };
}

export function CreateTaskTemplateRequestToJSON(json: any): CreateTaskTemplateRequest {
    return CreateTaskTemplateRequestToJSONTyped(json, false);
}

export function CreateTaskTemplateRequestToJSONTyped(value?: CreateTaskTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'priority': value['priority'],
        'dueDaysOffset': value['dueDaysOffset'],
        'assigneeRole': value['assigneeRole'],
        'displayOrder': value['displayOrder'],
        'isRequired': value['isRequired'],
    };
}

